import { render, staticRenderFns } from "./UserDetailsAdministrationTabsGroups.vue?vue&type=template&id=844ec5fe&"
import script from "./UserDetailsAdministrationTabsGroups.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationTabsGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports